export function formatStringForComparableFormat(string: string, keepAtSymbol: boolean = false): string {
  const regex = keepAtSymbol ? /([\u0300-\u036f]|[^0-9a-zA-Z._@ ])/g : /([\u0300-\u036f]|[^0-9a-zA-Z._ ])/g
  return string.toString().normalize('NFD').replace(regex, '').toLowerCase().trim()
}

export function formatStringForAwsFileBucketFormat(fileName: string): string {
  let formatedFileName: string = fileName.normalize('NFD').replace(/([\u0300-\u036f]|[^0-9a-zA-Z. ])/g, '')
  formatedFileName = formatedFileName.replace(/ /g, '_')

  return formatedFileName
}

export function formatStringToAlphanumeric(value: string, maxLength?: number): string {
  const formatted = value
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^0-9a-zA-Z ]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
  return maxLength ? formatted.substring(0, maxLength) : formatted
}

export function formatStringTruncatedAtDelimiter(value: string, delimiter: string): string {
  const delimiterIndex: number = value?.indexOf(delimiter) ?? -1
  return delimiterIndex > 0 ? `${value.substring(0, delimiterIndex)}...` : value
}

export function formatStringWithHtmlTags(stringWithHtmlTags: string): string {
  const breakwordTags = /<(p|br|div|hr|li|ul|ol|h[1-6])\b[^>]*>/gi
  stringWithHtmlTags = stringWithHtmlTags.replace(breakwordTags, ' ')
  stringWithHtmlTags = stringWithHtmlTags.replace(/<[^>]*>/g, '')
  stringWithHtmlTags = stringWithHtmlTags.replace(/\s+/g, ' ').trim()

  return stringWithHtmlTags
}

export function formatStringToNumericOnly(value: string | null | undefined): string {
  if (!value) return ''
  return (value ?? '').replace(/[^0-9]/gi, '')
}

export function formatListToSentence(items: Array<string>, conjunction: string = 'e'): string {
  if (items.length <= 1) return items.join('')
  return `${items.slice(0, -1).join(', ')} ${conjunction} ${items[items.length - 1]}`
}
